import { render } from "./expertreportcontenteditor.vue?vue&type=template&id=57951544"
import script from "./expertreportcontenteditor.vue?vue&type=script&lang=js"
export * from "./expertreportcontenteditor.vue?vue&type=script&lang=js"

import "./expertreportcontenteditor.vue?vue&type=style&index=0&id=57951544&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__